import { I18n } from 'react-redux-i18n';

import { api, mergeParams, wrapParams } from '../../api';
import { SHOW_LOADING, HIDE_LOADING } from './types/loadingTypes';

import { showToast } from './toastrActions';


export function getAccountsByHolding(holdingId) {

  return (dispatch) => {

    dispatch({
      type: SHOW_LOADING,
    });

    return new Promise((resolve, reject) => {

      api.get('Account/AllUsers', { params: { holdingId } }).then((response) => {

        dispatch({
          type: HIDE_LOADING,
        });

        resolve(response.data.return);

      }, (error) => {

        dispatch({
          type: HIDE_LOADING,
        });

        reject(error.response.data.return);

      });

    });

  };

}

export function accountByUserId(userId) {

  return (dispatch) => {

    dispatch({
      type: SHOW_LOADING,
    });

    return new Promise((resolve, reject) => {

      api.get('Account/AccountByUserId', { params: { userId } }).then((response) => {

        dispatch({
          type: HIDE_LOADING,
        });

        resolve(response.data.return);

      }, (error) => {

        dispatch({
          type: HIDE_LOADING,
        });

        reject(error.response.data.return);

      });

    });

  };

}

export function accountByHoldingId(holdingId) {

  return (dispatch) => {

    dispatch({
      type: SHOW_LOADING,
    });

    return new Promise((resolve, reject) => {

      api.get('Account/AccountByHoldingId', { params: { holdingId } }).then((response) => {

        dispatch({
          type: HIDE_LOADING,
        });

        resolve(response.data.return);

      }, (error) => {

        dispatch({
          type: HIDE_LOADING,
        });

        reject(error.response.data.return);

      });

    });

  };

}

export function getAccountById(userId) {

  return (dispatch) => {

    dispatch({
      type: SHOW_LOADING,
    });

    return new Promise((resolve, reject) => {

      api.get('Account/EditUser', { params: { userId } }).then((response) => {

        dispatch({
          type: HIDE_LOADING,
        });

        resolve(response.data.return);

      }, (error) => {

        dispatch({
          type: HIDE_LOADING,
        });

        reject(error.response.data.return);

      });

    });

  };

}

export function save(data) {

  return (dispatch) => {

    dispatch({
      type: SHOW_LOADING,
    });

    let request;

    if (data.idUser) {

      let updateData = {
        idUser: data.idUser,
        name: data.name,
        email: data.email,
        password: data.password,
        lstCompany: data.lstCompany,
      };

      request = api.post('Account/UpdateUser', wrapParams(updateData));

    } else {

      request = api.post('Account/CreateUser', wrapParams(data));

    }


    return new Promise((resolve, reject) => {

      request.then(
        (response) => {

          dispatch({
            type: HIDE_LOADING,
          });

          showToast('success', '', 'Dados do Usuário salvos com sucesso');

          resolve(response);

        },
        (error) => {

          dispatch({
            type: HIDE_LOADING,
          });

          showToast('error', '', 'Ocorreu um erro ao salvar os dados do Usuário');

          reject(error.response.data.errors);

        },
      );

    });

  };

}

export function statusUpdate(data) {

  return (dispatch) => {

    dispatch({
      type: SHOW_LOADING,
    });

    let request;

    request = api.put('Account/UpdateStatus', wrapParams(data));


    return new Promise((resolve, reject) => {

      request.then(
        (response) => {

          dispatch({
            type: HIDE_LOADING,
          });

          showToast('success', '', 'Dados do Usuário salvos com sucesso');

          resolve(response);

        },
        (error) => {

          dispatch({
            type: HIDE_LOADING,
          });

          showToast('error', '', 'Ocorreu um erro ao salvar os dados do Usuário')

          reject(error.response.data.errors);

        },
      );

    });

  };

}

export function deleteAccount(idUser) {

  return (dispatch) => {

    dispatch({
      type: SHOW_LOADING,

    });

    return new Promise((resolve, reject) => {

      api.delete('Account/DeleteUser', { params: { idUser } }).then(() => {

        dispatch({
          type: HIDE_LOADING,
        });

        showToast('success', '', 'Registro de Usuário deletado');
        resolve();

      }, (error) => {

        dispatch({
          type: HIDE_LOADING,
        });

        showToast('error', '', 'Ocorreu um erro ao deletar os dados do Usuário');
        reject(error.response.data.errors);

      });

    });

  };

}



// WEBPACK FOOTER //
// ./src/redux/actions/accountActions.js